import { isBoolean } from 'lodash';
import {
  getDataFromServer,
  postDataToServer,
  putDataToServer,
  postDataToServerWithFullResponse
} from '../../../util';

export class TicketsDashboard {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchTicketsList = async (payload) => {
    const url = `${this.baseURL}/requests`;
    const { page = 1, pageSize = 20, sourceId } = payload;
    const params = {
      limit: pageSize,
      offset: (page - 1) * pageSize,
      sourceId: sourceId
    };
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (data) {
      return data;
    } else {
      return [];
    }
  };

  approveRejectTickets = async (payload) => {
    const { actionType = '', instanceID = '', note = null } = payload;
    const params = {
      note
    };
    const url = `${this.baseURL}/requests/${instanceID}?action=${actionType}`;
    return await putDataToServer(url, this.httpHeaders, params).then(
      async (data) => {
        return this.fetchTicketsList({ page: 1, pageSize: 20 });
      }
    );
  };

  fetchCurrentChampion = async (payload) => {
    const { sourceId, scheduled } = payload;
    const params = {
      sourceId,
      scheduled
    };
    const url = `${this.baseURL}/challengers/currentChampion`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (data) {
      return data;
    } else {
      return [];
    }
  };

  fetchCurrentChallenger = async (payload) => {
    const { challengerID } = payload;
    const url = `${this.baseURL}/requests/${challengerID}`;
    const data = await getDataFromServer(url, this.httpHeaders, {});
    if (data) {
      return data;
    } else {
      return [];
    }
  };

  createChallenger = async (payload) => {
    const url = `${this.baseURL}/challengers`;
    const {
      challengerName,
      instanceId,
      selectedTypologyIds,
      unselectedTypologyIds,
      reasonMessage,
      fromDate,
      toDate,
      scheduled,
      allRules
    } = payload;
    const params = {
      challengerName,
      instanceId: parseInt(instanceId),
      selectedTypologyIds,
      unselectedTypologyIds,
      reasonCode: null,
      reasonMessage,
      fromDate,
      toDate,
      scheduled,
      allRules
    };
    const response = await postDataToServerWithFullResponse(url, params);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  };

  fetchChallengerSummaries = async (payload) => {
    const { sourceId = '', scheduled } = payload;
    const url = `${this.baseURL}/challengers/summaries`;
    const params = { sourceId, scheduled };
    return await getDataFromServer(url, this.httpHeaders, params);
  };

  revertCurrentChampion = async (payload) => {
    const { currentChampionId, scheduled } = payload;
    const url = `${this.baseURL}/challengers/revert/${currentChampionId}${
      isBoolean(scheduled) ? `?scheduled=${scheduled}` : ''
    }`;
    const response = await postDataToServerWithFullResponse(url);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  };

  promoteChallenger = async (payload) => {
    const { challengerId } = payload;
    const url = `${this.baseURL}/challengers/promote/${challengerId}`;
    const response = await postDataToServerWithFullResponse(url);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  };
}
